export default __webpack_public_path__ + "static/media/Royal Zingaran Blade.b024c4a0.jpg";